import { render, staticRenderFns } from "./AttachmentInf.vue?vue&type=template&id=5e1f5046&scoped=true&"
import script from "./AttachmentInf.vue?vue&type=script&lang=js&"
export * from "./AttachmentInf.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInf.vue?vue&type=style&index=0&id=5e1f5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f5046",
  null
  
)

export default component.exports